import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { SearchBarTable } from 'hljd'
import Store from './store'
import { PATH_ZTB, ORDER_TOP, ORDER_DOWN, ORDER_UP } from '../constant'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { Alert } from 'hljd'
import Empty, { ZhiTuiBao } from '../Empty'
import styles from './style.module.less'
import cls from 'classnames'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    const { changeOrder, $pagination } = this.store

    return (
      <HeaderView
        header={[<Link to={PATH_ZTB}>智推宝</Link>, '激活顺序设置']}
        title="激活顺序设置"
      >
        <Alert
          message="为保证您的投放效果，系统将在套包到期后，为您自动开通新的套包，您可在此页面调整套包的自动激活顺序，先激活的在前。"
          type="info"
          showIcon
          style={{ margin: '20px 0' }}
        />

        <SearchBarTable
          locale={{
            emptyText: <Empty content={ZhiTuiBao} />
          }}
          pagination={false}
          store={this.store}
          columns={[
            {
              title: '套包类型',
              dataIndex: 'title',
              width: 200
            },
            {
              title: '购买时间',
              width: 200,
              dataIndex: 'created_at',
              render: created_at => {
                return <span>{created_at.split(' ')[0]}</span>
              }
            },
            {
              title: '操作',
              dataIndex: 'operation',
              width: 120,
              render: (o, { id }, index) => {
                const { total } = $pagination
                return (
                  <div>
                    {/* 上移 */}
                    {index != 0 ? (
                      <img
                        src="//qnm.hunliji.com/FjtyP2jzXx5bXPXrQm0aKG7JI7W8"
                        onClick={() => {
                          changeOrder(id, ORDER_UP)
                        }}
                        className={styles.orderIcon}
                      />
                    ) : (
                      <img
                        src="//qnm.hunliji.com/FpLdmyPy4asmd6SAOD1ktuJqgrQm"
                        className={cls(styles.orderIcon, styles.disable)}
                      />
                    )}

                    {/* 下移 */}
                    {index + 1 != total ? (
                      <img
                        src="//qnm.hunliji.com/Fokzud4W__wmIQ-1cw2TKiQMMJH-"
                        onClick={() => {
                          changeOrder(id, ORDER_DOWN)
                        }}
                        className={styles.orderIcon}
                      />
                    ) : (
                      <img
                        src="//qnm.hunliji.com/Fnq-YSLZovHKHClD5kycJgfJDjUB"
                        className={cls(styles.orderIcon, styles.disable)}
                      />
                    )}

                    {index != 0 ? (
                      <img
                        src="//qnm.hunliji.com/Fk1V6hOIi9O_gnFLkr-YA_Ei4OFi"
                        onClick={() => {
                          changeOrder(id, ORDER_TOP)
                        }}
                        className={styles.orderIcon}
                      />
                    ) : (
                      <img
                        src="//qnm.hunliji.com/FoueGP4csSPrlFT1_t0RHQTWRcQT"
                        className={cls(styles.orderIcon, styles.disable)}
                      />
                    )}
                  </div>
                )
              }
            }
          ]}
        />
      </HeaderView>
    )
  }
}
